<template>
    <!--操作日志 -->
    <div :class="phoneClass || 'log-list-container'">
        <content-header>
        </content-header>
        <div class="store-table">
            <div class="table-outer">
                <el-table :data="logList" :header-cell-style="{background:'#fafbfc'}" class="normal-table" style="width: 100%">
                    <el-table-column min-width="170px"  :label="$t('devicePage.imei')" >
                        <el-tooltip v-if="scope.row.outer_device_id" slot-scope="scope" :content="'电信平台ID: '+scope.row.outer_device_id" placement="top">
                            <div>{{scope.row.imei}}</div>
                        </el-tooltip>
                        <div v-else slot-scope="scope">
                            <div>{{scope.row.imei}}</div>
                        </div>
                    </el-table-column>
                    <!--状态-->
                    <el-table-column  min-width="140px" :label="$t('devicePage.equipmentStatus')">
                        <div class="table-outer-status" slot-scope="scope">
                            <div v-if="scope.row.status === 0">
                                <el-alert
                                        :title="$t('selectData.device.status.status0')"
                                        type="success"
                                        style="color:#88c008"
                                        :closable="false">
                                </el-alert>
                            </div>
                            <div v-else-if="scope.row.status === 1">
                                <el-alert
                                        :title="$t('selectData.device.status.status1')"
                                        type="warning"
                                        style="color:#eb202a"
                                        :closable="false">
                                </el-alert>
                            </div>
                            <div v-else-if="scope.row.status === 2">
                                <el-alert
                                        :title="$t('selectData.device.status.status2')"
                                        type="error"
                                        style="color:#ff8004"
                                        :closable="false">
                                </el-alert>
                            </div>
                            <div v-else-if="scope.row.status === 3">
                                <el-alert
                                        :title="$t('selectData.device.status.status3')"
                                        type="info"
                                        style="color:white;background: #99a5aa"
                                        :closable="false">
                                </el-alert>
                            </div>
                            <div v-else-if="scope.row.status === 4">
                                <el-alert
                                        :title="$t('selectData.device.status.status4')"
                                        type="info"
                                        style="color:white;background: #99a5aa"
                                        :closable="false">
                                </el-alert>
                            </div>
                            <div v-if="scope.row.pending_setting === 0" style="margin-left: 5px">
                                <el-alert
                                        :title="'待关机'"
                                        type="info"
                                        style="color:#D3D3D3;background: #F8E71C"
                                        :closable="false">
                                </el-alert>
                            </div>
                        </div>
                    </el-table-column>
                    <el-table-column :label="$t('devicePage.error')" min-width="250px" >
                        <!--<div v-for="" slot-scope="scope" style="color: #717A81;">-->
                        <!--</div>-->
                        <template slot-scope="scope" style="white-space: pre-wrap;">
                            <!--<img src="" alt="">-->
                            {{scope.row.error_type | filterErrorType}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" min-width="180px" :label="$t('devicePage.warning')">
                        <div slot-scope="scope">
                            {{scope.row.last_report_time | timeFormat(1)}}
                        </div>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination" style="text-align:right;padding:20px;">
                <el-pagination
                        @current-change="pageChange"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        layout="total, prev, pager, next"
                        :total="total"
                        background>
                </el-pagination>
            </div>
        </div>
    </div>
</template>


<script>
	import Core from "core/core";
	import contentHeader from '../../components/content-header'
	import {refresh} from "core/winSize"
	export default {
		data() {
			return {
			    device_id: '',
				phoneClass: '',
				logList: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
			};
		},
		components: {
			contentHeader
		},
		created() {
			refresh(this,'phoneClass-log-list-container');
			window.onresize = function(){
				setTimeout(function(){
					refresh(this,'phoneClass-log-list-container');
				},10)
			};
		},
		mounted() {
			this.getLogList();
		},
		computed: {
		},
		methods: {
			getLogList() {
				Core.Api.DeviceAlarmLog.list(this.currentPage)
				.then(res => {
					this.total = res.count
					this.logList = res.list
					console.log(res,'log');
				})

			},
			pageChange(val) {
				this.currentPage = val;
				this.getLogList();
			},
		},


	};
</script>

<style scoped lang="scss">
    @import '../../assets/style/mixin.scss';
    .log-list-container {
        background-color: #E5EBEF;
        height: 100%;
        .store-table {
            margin: 30px 40px;
            background-color: #FFFFFF;
            .search-bar {
                @include flex-sb;
                padding: 20px;
                .status-index {
                    margin-right: 12px;
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
            .table-outer {
                padding: 0 20px;
            }
        }
    }
</style>

<style lang="scss">
    .log-list-container {
        .table-outer {
            .cell {
                white-space:nowrap;
                overflow:hidden; //超出的文本隐藏
                text-overflow:ellipsis; //溢出用省略号显示
            }
            .cell:hover {
                /*background: #e2e2e2;*/
                white-space: normal;
                overflow: visible; //超出的文本隐藏
                position: relative;
                z-index: 10000;
                text-overflow:clip;
                /*background: #f6f7fb;*/
            }

        }

        .normal-table {
            /*状态样式*/
            .table-outer-status {
                >div{
                    display: inline-block !important;
                    white-space:nowrap !important;
                }
            }
            .el-alert {
                margin: 0;
                padding: 0;
                min-width: 48px;
                height: 26px;
                font-size: 10px !important;
                .el-alert__content{
                    margin: 0 auto;
                    padding: 0;
                    .el-alert__title {
                        margin: 0 auto;
                        font-size: 10px !important;
                    }
                }
            }
        }

    }
    //配置移动端时间选择
    .phoneClass-log-list-container {
        .store-table {
            .search-bar {
                padding-left: 10px;
                .status-index {
                    margin-top: 15px;
                    .el-date-editor {
                        margin-left: 0 !important;
                        min-width: 300px;
                        max-width: 90vw;
                    }
                }
            }
            .table-outer {
                margin-top: 15px;
            }
            /*页码适配移动端*/
            .pagination {
                padding: 20px 0 !important;
                text-align: center !important;
                .el-pagination {
                    padding: 0;
                    button {
                        width: 20px;
                        min-width: 0;
                        height: 30px;
                    }
                    .el-pager {
                        .number {
                            margin: 0 3px !important;
                            padding: 0 !important;
                            min-width: 0px;
                            width: 20px !important;
                            height: 30px !important;
                        }
                        .el-icon-more {

                            margin: 0 3px !important;
                            padding: 0 !important;
                            min-width: 0px;
                            width: 20px !important;
                            height: 30px !important;
                        }
                    }
                }
            }
        }
        .normal-table {
            /*状态样式*/
            .table-outer-status {
                >div{
                    display: inline-block !important;
                }
            }
            .el-alert {
                margin: 0;
                padding: 0;
                width: 48px;
                height: 26px;
                font-size: 10px !important;
                .el-alert__content{
                    margin: 0 auto;
                    padding: 0;
                    .el-alert__title {
                        margin: 0 auto;
                        font-size: 10px !important;
                    }
                }
            }
        }
    }
    /*.el-popper,*/
    .el-date-range-picker {
        left: 0 !important;
        .el-picker-panel__body-wrapper {
            .el-picker-panel__body{
                min-width: 300px;
                max-width: 100vw;

                >div>div>div {
                    font-size: 16px;
                    margin: 0;
                }
            }
        }
    }
</style>
